module.exports = require("./index");


//////////////////
// WEBPACK FOOTER
// external "./index"
// module id = 1
// module chunks = 0